import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface IItemModel {
	group: string;
	text: string;
	selected: boolean;
}

@Component({
	selector: 'app-grouped-multiselect',
	templateUrl: './grouped-multiselect.component.html',
	styleUrls: ['./grouped-multiselect.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class GroupedMultiSelectComponent implements OnInit {
	@Input() items: IItemModel[];
	@Output() itemsChange = new EventEmitter<IItemModel[]>();
	@Input() allGroupsLabel: string;
	@Input() ungroupedLabel: string;
	@Input() public filterLabel: string;

	readonly allGroupKey = '<AllGroupKey>';
	selectedItems: IItemModel[] = [];
	groupedItems = new Map<string, IItemModel[]>();
	groups: string[] = [];
	currentGroup = this.allGroupKey;
	filterString = '';

	constructor() {}

	ngOnInit(): void {
		this.groupItems();
	}

	onFilterChange() {
		this.groupItems();
	}

	onItemClicked(item: IItemModel) {
		item.selected = true;
		this.groupItems();
		this.itemsChange.emit(this.items);
	}

	onSelectedItemClicked(item: IItemModel) {
		item.selected = false;
		this.groupItems();
		this.itemsChange.emit(this.items);
	}

	onGroupClicked(group: string) {
		const g = this.groupedItems.get(group);
		g.forEach((item: IItemModel) => (item.selected = true));
		this.groupItems();
		this.itemsChange.emit(this.items);
	}

	private groupItems() {
		const lowerCaseFilterString = this.filterString.toLowerCase();
		this.groupedItems = new Map<string, IItemModel[]>();
		this.selectedItems = [];
		this.items.forEach((item: IItemModel) => {
			const groupName = item.group?.trim() || this.ungroupedLabel;
			if (item.selected) {
				this.selectedItems.push(item);
			} else if (!this.filterString || item.text.toLowerCase().includes(lowerCaseFilterString)) {
				if (!this.groupedItems.has(groupName)) {
					this.groupedItems.set(groupName, []);
				}
				this.groupedItems.get(groupName)?.push(item);
			}
		});
		this.groups = [...this.groupedItems.keys()];
		if (this.currentGroup !== this.allGroupKey && !this.groups.includes(this.currentGroup)) {
			this.groups.push(this.currentGroup);
		}
		this.selectedItems = this.selectedItems.sort((a, b) => a.text.localeCompare(b.text));
	}
}
